/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EdictTransferOutcome = {
    Created: 'Created',
    Updated: 'Updated',
    NotInEdict: 'NotInEdict',
    NoCounselor: 'NoCounselor',
    HearingTimeMissing: 'HearingTimeMissing',
    DeadlinePassed: 'DeadlinePassed',
    HearingPassed: 'HearingPassed'
} as const;
export type EdictTransferOutcome = typeof EdictTransferOutcome[keyof typeof EdictTransferOutcome];


export function instanceOfEdictTransferOutcome(value: any): boolean {
    for (const key in EdictTransferOutcome) {
        if (Object.prototype.hasOwnProperty.call(EdictTransferOutcome, key)) {
            if (EdictTransferOutcome[key as keyof typeof EdictTransferOutcome] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EdictTransferOutcomeFromJSON(json: any): EdictTransferOutcome {
    return EdictTransferOutcomeFromJSONTyped(json, false);
}

export function EdictTransferOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictTransferOutcome {
    return json as EdictTransferOutcome;
}

export function EdictTransferOutcomeToJSON(value?: EdictTransferOutcome | null): any {
    return value as any;
}

export function EdictTransferOutcomeToJSONTyped(value: any, ignoreDiscriminator: boolean): EdictTransferOutcome {
    return value as EdictTransferOutcome;
}

